import { render, staticRenderFns } from "./CompartmentsList.vue?vue&type=template&id=65f23f16&"
import script from "./CompartmentsList.vue?vue&type=script&lang=js&"
export * from "./CompartmentsList.vue?vue&type=script&lang=js&"
import style0 from "./CompartmentsList.vue?vue&type=style&index=0&id=65f23f16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports